export const gs = 2;
export const lightLila = "#F7F6FF"
